import React, { useState } from 'react';
import { Button } from '@this/components/shared/ui/inputs/button';
import OrganizationModal from './organization_modal';
import OperationRuleModal from './operation_rule_modal';

interface Props {
  organizationId: number;
  showHeading?: boolean;
}

export const OrganizationAsideButtons: React.FC<Props> = ({ organizationId, showHeading = false }) => {
  const [showOperationRuleModal, setShowOperationRuleModal] = useState(false);
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);

  return (
    <>
      {showHeading && <h3 style={{ marginBottom: '4px' }}>企業情報</h3>}
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <Button onClick={() => setShowOperationRuleModal(true)}>運用ルール</Button>
        <Button onClick={() => setShowOrganizationModal(true)}>企業情報</Button>
      </div>
      <OperationRuleModal
        show={showOperationRuleModal}
        organizationId={organizationId}
        onClose={() => setShowOperationRuleModal(false)}
      />
      <OrganizationModal
        show={showOrganizationModal}
        organizationId={organizationId}
        onClose={() => setShowOrganizationModal(false)}
      />
    </>
  );
};
